/** Canonical native bundle product handles — one cart line, Shopify bundle pricing. */
(() => {
  const handles = [
    'ghalia-infinity-ring-duo',
    'knot-bridge-duo-silver',
    'knot-bridge-duo-gold',
    'ghalia-knot-hero-set-gold',
    'ghalia-knot-hero-set-silver',
    'ghalia-knot-two-tone-ring-stack',
    'ghalia-knot-wrist-story',
    'ghalia-pave-gold-stack',
    'ghalia-pave-silver-stack',
    'ghalia-cross-ring-earring-gold',
  ];
  window.GhaliaNativeBundleHandles = new Set(handles);
  window.GhaliaNativeBundleDiscounts = {
    'ghalia-infinity-ring-duo': 8,
    'knot-bridge-duo-silver': 8,
    'knot-bridge-duo-gold': 8,
    'ghalia-knot-hero-set-gold': 10,
    'ghalia-knot-hero-set-silver': 10,
    'ghalia-knot-two-tone-ring-stack': 8,
    'ghalia-knot-wrist-story': 8,
    'ghalia-pave-gold-stack': 10,
    'ghalia-pave-silver-stack': 10,
    'ghalia-cross-ring-earring-gold': 5,
  };
  window.GhaliaNativeBundleAnchors = new Set([
    'infinity-bridge-ring',
    'single-infinity-pave-ring',
    'knot-bridge-ring-silver',
    'knot-bridge-bracelet-silver',
    'knot-bridge-bracelet-gold',
    'knot-bridge-ring-gold-1',
    'knot-bracelet-gold',
    'knot-bracelet-silver',
    'knot-ring-gold',
    'knot-ring-silver',
    'knot-hoop-earring-gold',
    'knot-hoop-earring-silver',
    'pave-dainty-ring-gold',
    'pave-initial-ring-gold',
    'pave-signet-ring-gold',
    'pave-dainty-ring-silver',
    'pave-initial-ring-silver',
    'pave-signet-ring-silver',
  ]);
})();
